import { useTranslation } from 'react-i18next';
import { SelectableTableColumn } from '../../components/SelectableTable/SelectableTable.types';

export const useExamineeTableColumns = () => {
  const { t } = useTranslation();

  const columns: SelectableTableColumn[] = [
    {
      id: 'id',
      type: 'checkbox',
      title: '',
      filterType: null,
      sortable: false,
    },
    {
      id: 'examCommittee',
      type: 'text',
      title: t('examinees:table.examCommittee'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'schoolCode',
      type: 'text',
      title: t('examinees:table.schoolCode'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'examineeCode',
      type: 'text',
      title: t('examinees:table.examineeCode'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'examineePesel',
      type: 'text',
      title: t('examinees:table.examineePesel'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'examName',
      type: 'text',
      title: t('examinees:table.examName'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'sheetCode',
      type: 'text',
      title: t('examinees:table.sheetCode'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'room',
      type: 'text',
      title: t('examinees:table.room'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'importDate',
      type: 'date',
      title: t('examinees:table.importDate'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'status',
      type: 'text',
      title: t('examinees:table.status'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'adjustments',
      type: 'text',
      title: t('examinees:table.adjustments'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'actions',
      type: 'actions',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  return { columns };
};
